import { useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { DiliTextCP } from "../Utility/DiliTextCP";
import {
  // dateAfterDeliveryDate,
  isValidEmail,
  // prependBasePath,
} from "../../helpers/utilities";
// import { tokenKeyName } from "../../config.json";
// import jwtDecode from "jwt-decode";
import { getProfileInformation, isClient } from "../../services/accountService";
// import { NumberInput } from "../Utility/NumberInput";
import { basePath } from "../../config";
import * as constants from "../../constants";
import {
  getMostRecentRouteUpdateForRoute,
  postDeliveryConcern,
} from "../../services/deliveryConcernService";
import handleApiError from "../../helpers/handleApiError";
import { toast } from "react-toastify";
import { postClaim } from "../../services/claimService";
import {
  postReturn,
  postManualReturn,
  getLabelsForMultipleDeliveries,
} from "../../services/deliveryService";
import { useEffect } from "react";
import { format as dateFormat } from "date-fns";
import { IoMdWarning } from "react-icons/io";
// import { PhoneInputComponent } from "../Utility/PhoneInputComponent";
import { canInitiateCODResearch } from "../../helpers/orderActionsUtilities";
import { TooltipInfoHover } from "../Utility/TooltipInfoHover";
import {
  compressionStatuses,
  convertMBToBytes,
  FileUploadV2,
} from "../Utility/FormElements/FileUploadV2";
// import fileDownload from "js-file-download";

const genericMaxLength = 50;
const genericTextAreaMaxLength = 500;
const deliveryConcernProblemDescriptionMaxLength = 450;
const DeliveryConcernAndCodResearchForm = ({
  mode,
  setMode,
  profileInfo,
  orderInfo,
  clientJWTInfo,
  history,
  setLoading,
}) => {
  // const [deliveryConcernFormData, setDeliveryConcernFormData] = useState({
  //   contactEmail: profileInfo
  //     ? profileInfo.userEmailAddresses.split(";")[0]
  //     : "",
  //   contactPhone: "",
  //   // contactName: jwtDecode(localStorage.getItem(tokenKeyName)).given_name,
  //   contactName: profileInfo ? profileInfo.userName : "",
  //   problemDescription: "",
  // });
  // const [codResearchFormData, setCodResearchFormData] = useState({
  //   contactEmail: profileInfo
  //     ? profileInfo.userEmailAddresses.split(";")[0]
  //     : "",
  //   customer: orderInfo ? orderInfo.customerName : "",
  //   codDate: "",
  //   codAmount: orderInfo ? orderInfo.codAmount : "",
  //   problemDescription: "",
  // });
  // console.log(orderInfo);
  // console.log(orderInfo.codAmount);
  // console.log(profileInfo);
  const [combinedFormData, setCombinedFormData] = useState({
    contactEmail: profileInfo
      ? profileInfo.userEmailAddresses.split(";")[0]?.trim()
      : "",
    contactName: profileInfo ? profileInfo.userName : "",
    contactPhone: "",
    problemDescription: "",
    customer: orderInfo ? orderInfo.customerName : "",
    amount: orderInfo ? orderInfo.codAmount : "",
  });

  const [routeUpdate, setRouteUpdate] = useState();

  useEffect(() => {
    const fetchData = async () => {
      if (orderInfo.route) {
        try {
          setLoading(true);
          // console.log(orderInfo.route);
          const response = await getMostRecentRouteUpdateForRoute(
            orderInfo.route
          );
          // console.log(response);
          setRouteUpdate(response.data);
          setLoading(false);
        } catch (ex) {
          handleApiError(ex, history);
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [orderInfo]);

  // console.log(orderInfo?.customerName);
  const handleChangeActionType = (e) => {
    setMode(e.target.value);
  };

  // const handleDeliveryConcernFormChange = (e) => {
  //   setDeliveryConcernFormData({
  //     ...deliveryConcernFormData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  // const handleCodResearchFormChange = (e) => {
  //   setCodResearchFormData({
  //     ...codResearchFormData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const [IsManualEmailEntry, setIsManualEmailEntry] = useState(
    profileInfo?.userEmailAddresses?.length === 0
  );
  // console.log(IsManualEmailEntry);

  const handleCombinedFormChange = (e) => {
    if (e.target.value === "notlisted") {
      setCombinedFormData({ ...combinedFormData, contactEmail: "" });
      setIsManualEmailEntry(true);
    } else {
      setCombinedFormData({
        ...combinedFormData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const [wasSubmitted, setWasSubmitted] = useState(false);
  // const [wasSubmittedSuccessfullyNotification, setWasSubmittedSuccessfullyNotification] = useState(false); // don't need for now as we redirec to a diff page.

  const handleOnInvalid = () => {
    setWasSubmitted(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log(combinedFormData);
    setWasSubmitted(true);
    let deliveryConcernTypeId;
    if (mode === modeTitles.deliveryconcern) {
      deliveryConcernTypeId = 1;
    } else if (mode === modeTitles.codresearch) {
      deliveryConcernTypeId = 2;
    }

    const concernPostBody = {
      deliveryId: orderInfo.deliveryId,
      deliveryConcernTypeId,
      ...combinedFormData,
      contactEmail:
        combinedFormData.contactEmail === "all"
          ? profileInfo?.userEmailAddresses
          : combinedFormData.contactEmail,
    };
    try {
      //for concerns or cod research
      // console.log(concernPostBody);
      setLoading(true);
      // console.log(concernPostBody);
      const concernPostResponse = await postDeliveryConcern(concernPostBody);
      toast.success("Your concern has been submitted successfully.");
      history.push("/delivery-concern"); //send to delivery concern table on success
      // console.log(concernPostResponse);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      toast.error("There was an issue submitting your concern.");
      handleApiError(ex);
    }

    // if (mode === modeTitles.deliveryconcern) {
    //   console.log({
    //     deliveryId: orderInfo.deliveryId,
    //     deliveryConcernTypeId: 1, //1 for delivery concern
    //     ...deliveryConcernFormData,
    //   });
    // } else if (mode === modeTitles.codresearch) {
    //   console.log({
    //     deliveryId: orderInfo.deliveryId,
    //     deliveryConcernTypeId: 2, //2 for cod research
    //     ...codResearchFormData,
    //   });
    // }
  };
  // console.log(profileInfo);
  // console.log(orderInfo);

  const contactEmailOptions = useMemo(() => {
    //"".split(";") returns [""] so we need to return [] if useremailaddresses = "" / length is 0 or else there will be an empty option
    if (profileInfo?.userEmailAddresses.length > 0) {
      return profileInfo?.userEmailAddresses?.split(";").map((email, index) => {
        const trimmedEmail = email.trim();
        return (
          <option key={index + "-" + trimmedEmail} value={trimmedEmail}>
            {trimmedEmail}
          </option>
        );
      });
    } else {
      return [];
    }
  }, [profileInfo]);

  // console.log(combinedFormData.contactEmail);
  const validPhone =
    combinedFormData?.contactPhone?.split("-")[0]?.length === 3 &&
    combinedFormData?.contactPhone?.split("-")[1]?.length === 3 &&
    combinedFormData?.contactPhone?.split("-")[2]?.length === 4;
  // console.log(combinedFormData.contactPhone);
  const codResearchDisabled = !canInitiateCODResearch(
    orderInfo.status,
    new Date(orderInfo.deliveryDate),
    orderInfo.isCod
  ).ableTo;

  return (
    <form onSubmit={handleSubmit} onInvalid={handleOnInvalid}>
      <div className="paper-panel sub-panel">
        <div className="row sub-panel-header align-items-sm-center">
          <div className="col-md-6 text-center text-md-left">
            <span className="h5">{mode}</span>
          </div>
          {(mode === modeTitles.deliveryconcern ||
            mode === modeTitles.codresearch) &&
            orderInfo.isCod && (
              <div className="col-md-6 d-flex justify-content-end">
                <select
                  name="actionType"
                  value={mode}
                  onChange={handleChangeActionType}
                  className="form-control action-center-action-type-dropdown mx-4 mx-md-0 my-2 my-md-0"
                >
                  <option value={modeTitles.deliveryconcern}>
                    Delivery Concern
                  </option>
                  <option
                    value={modeTitles.codresearch}
                    className={codResearchDisabled ? "disabled-option" : ""}
                    disabled={codResearchDisabled}
                  >
                    COD Research
                  </option>
                </select>
              </div>
            )}
        </div>
        <div className="row px-4">
          {/* <div className="col-lg-4"></div> */}
          {mode === modeTitles.deliveryconcern && (
            <>
              {routeUpdate && (
                <div className="col-12">
                  <div
                    className="row"
                    style={{
                      backgroundColor: "#e9ecef",
                      padding: "10px",
                      margin: "10px",
                    }}
                  >
                    <div className="col-md-12">
                      There is a recent alert for this route:
                    </div>
                    <div className="col-sm-9 font-500">
                      {routeUpdate.subject}
                    </div>
                    <div className="col-sm-3 text-sm-right">
                      <IoMdWarning style={{ verticalAlign: "top" }} />
                    </div>
                    <div className="col-12 font-500">
                      {dateFormat(new Date(routeUpdate.entered), "MM/dd/yyyy")}
                    </div>
                    <div className="col-12">
                      {
                        routeUpdate?.e_Body?.split(
                          "Thank you for choosing Diligent"
                        )[0]
                      }
                    </div>
                  </div>
                </div>
              )}
              {IsManualEmailEntry ? (
                <DiliTextCP
                  key="ManualEntry"
                  maxLength={120} //120 is prob enough for 1 email even if backend supports up to 500 right? (backend supports multiple emails as semicolon delimited string)
                  //also want to limit the above email to 120 as we want to support up to 5 email addresses (total of 480 characters, minus the semicolons, backend supports up to 500)
                  className="col-lg-4 form-group"
                  label="Contact Email (Manual)"
                  required
                  onChange={handleCombinedFormChange}
                  infoText={
                    profileInfo?.userEmailAddresses.length === 0
                      ? "You can add user email addresses in your profile page to select from them here later!"
                      : ""
                  }
                  name="contactEmail"
                  type="email"
                  validationTest={(input) => {
                    return isValidEmail(input);
                  }}
                  value={combinedFormData.contactEmail}
                ></DiliTextCP>
              ) : (
                <DiliTextCP
                  key="DropdownEntry"
                  className="col-lg-4 form-group"
                  required
                  label="Contact Email"
                  type="select"
                  onChange={handleCombinedFormChange}
                  name="contactEmail"
                  //dont need validation on dropdown version as it will always be a user email on their account OR a semicolon delimited string of all their user emails (which wouldn't be a valid email anyway so would need more logic)
                  // validationTest={(input) => {
                  //   return isValidEmail(input) || ;
                  // }}
                  value={combinedFormData.contactEmail}
                  wasSubmitted={wasSubmitted}
                >
                  <option value="all">All user emails on profile</option>
                  {contactEmailOptions}
                  <option value="notlisted">Another email</option>
                </DiliTextCP>
              )}
              {/* <DiliTextCP
                required
                maxLength={12}
                type="tel"
                className="col-lg-4 form-group"
                label="Contact Phone"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                helperText={"###-###-####"}
                validationTest={(input) => {
                  return validPhone;
                }}
                invalidText={
                  combinedFormData === ""
                    ? "Please enter a phone number."
                    : "Please match the format ###-###-####"
                }
                showHelperText
                validationTestOnBlur
                onChange={handleCombinedFormChange}
                name="contactPhone"
                value={combinedFormData.contactPhone}
              /> */}
              {/* <PhoneInputComponent
                className="col-lg-4 form-group"
                label="Contact Phone"
                required
                name="contactPhone"
                onChange={handleCombinedFormChange}
              /> */}
              <DiliTextCP
                type="tel"
                maxLength="12"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                className="col-lg-4 mb-4 mb-lg-0 form-group"
                label="Contact Phone"
                validationTest={(input) => {
                  return validPhone;
                }}
                validationTestOnBlur
                helperText={"555-555-5555"}
                helperTextStyle={{
                  position: "absolute",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                }}
                showHelperText
                invalidText={
                  "Please enter a phone number in the format 555-555-5555."
                }
                helperTextClass="text-note"
                required
                onChange={handleCombinedFormChange}
                name="contactPhone"
                value={combinedFormData.contactPhone}
                wasSubmitted={wasSubmitted}
              />
              <div className="col-4"></div>

              <DiliTextCP
                maxLength={genericMaxLength}
                className="col-lg-4 form-group"
                label="Contact Name"
                onChange={handleCombinedFormChange}
                name="contactName"
                value={combinedFormData.contactName}
                wasSubmitted={wasSubmitted}
              />

              <DiliTextCP
                maxLength={deliveryConcernProblemDescriptionMaxLength} //setting this description's maxlength count to 450 as even though in the db it is a varchar 500, on the backend we append a short message including the main invoice number of the order that takes up about 26 characters.
                className="col-12 form-group"
                required
                type="textarea"
                displayTextAreaCharacterCount
                label="Problem Description"
                onChange={handleCombinedFormChange}
                name="problemDescription"
                invalidText="Please enter a description of your problem."
                minLength="5" //not working?
                value={combinedFormData.problemDescription}
                wasSubmitted={wasSubmitted}
              />
            </>
          )}
          {mode === modeTitles.codresearch && (
            <>
              {/* <DiliTextCP
                maxLength={genericMaxLength}
                className="col-lg-4 form-group"
                required
                label="Contact Email"
                type="email"
                onChange={handleCombinedFormChange}
                name="contactEmail"
                validationTest={(input) => {
                  return isValidEmail(input);
                }}
                value={combinedFormData.contactEmail}
                wasSubmitted={wasSubmitted}
              /> */}
              {IsManualEmailEntry ? (
                <DiliTextCP
                  key="ManualEntry"
                  maxLength={120} //120 is prob enough for 1 email even if backend supports up to 500 right? (backend supports multiple emails as semicolon delimited string)
                  //also want to limit the above email to 120 as we want to support up to 5 email addresses (total of 480 characters, minus the semicolons, backend supports up to 500)
                  className="col-lg-4 form-group"
                  label="Contact Email (Manual)"
                  required
                  onChange={handleCombinedFormChange}
                  name="contactEmail"
                  type="email"
                  validationTest={(input) => {
                    return isValidEmail(input);
                  }}
                  value={combinedFormData.contactEmail}
                ></DiliTextCP>
              ) : (
                <DiliTextCP
                  key="DropdownEntry"
                  className="col-lg-4 form-group"
                  required
                  label="Contact Email"
                  type="select"
                  onChange={handleCombinedFormChange}
                  name="contactEmail"
                  //dont need validation on dropdown version as it will always be a user email on their account OR a semicolon delimited string of all their user emails (which wouldn't be a valid email anyway so would need more logic)
                  // validationTest={(input) => {
                  //   return isValidEmail(input) || ;
                  // }}
                  value={combinedFormData.contactEmail}
                  wasSubmitted={wasSubmitted}
                >
                  <option value="all">All user emails on profile</option>
                  {contactEmailOptions}
                  <option value="notlisted">Another email</option>
                </DiliTextCP>
              )}
              <DiliTextCP
                maxLength={genericMaxLength}
                className="col-lg-4 form-group"
                required
                label="Customer name"
                onChange={handleCombinedFormChange}
                name="customer"
                value={combinedFormData.customer}
                wasSubmitted={wasSubmitted}
              />
              <div className="col-4"></div>
              {/* <DiliTextCP
                maxLength={genericMaxLength}
                className="col-lg-4 form-group"
                label="Cod Date"
                type="date"
                onChange={handleCombinedFormChange}
                name="codDate"
                value={combinedFormData.codDate}
              /> */}
              <DiliTextCP
                maxLength={genericMaxLength}
                className="col-lg-4 form-group"
                required
                label="COD Amount"
                type="number"
                onChange={handleCombinedFormChange}
                name="amount"
                value={combinedFormData.amount}
                blockScientificNotation
                positiveOnly
                decimalPrecision="2"
                min="0"
                max="999999999"
                step=".01"
                wasSubmitted={wasSubmitted}
              />
              <DiliTextCP
                maxLength={genericTextAreaMaxLength}
                className="col-12 form-group"
                required
                label="Problem Description"
                invalidText="Please enter a description of your problem."
                type="textarea"
                onChange={handleCombinedFormChange}
                name="problemDescription"
                value={combinedFormData.problemDescription}
                wasSubmitted={wasSubmitted}
              />
            </>
          )}
        </div>
      </div>
      <p>
        By submitting your{" "}
        {mode === modeTitles.deliveryconcern
          ? "delivery concern"
          : "request for COD research"}
        , you agree to our{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer" //might not be necessary unless linking to a different site or in modern browsers. not 100% sure, need to research
          to={constants.pdfLinks.termsAndConditions}
        >
          terms and conditions
        </Link>
        .
      </p>
      <button type="submit" className="btn btn-primary">
        Submit
      </button>
    </form>
  );
};

const ClaimForm = ({
  mode,
  profileInfo,
  orderInfo,
  clientJWTInfo,
  history,
  setLoading,
}) => {
  const [claimFormData, setClaimFormData] = useState({
    emailAddress: profileInfo
      ? profileInfo.userEmailAddresses.split(";")[0]?.trim()
      : "",
    claimNo: "",
    amount: "",
    partNo: "",
    partDescription: "",
    claimType: "Lost Freight",
    caller: "",
    comment: "",
    files: [],
    compressingFiles: false,
    totalFileSize: 0,
  });
  const TOTAL_FILE_SIZE_LIMIT = 10;
  const handleChangeFiles = (fileObjects) => {
    //FileUpload component handleChangeFiles event returns an array of fileObjects which include a file and a src if you need to handle displaying stuff in the parent.
    setClaimFormData((prev) => {
      return {
        ...prev,
        files: fileObjects.map((fileObject) => fileObject.file), // only need to store/send files for this
        compressingFiles:
          fileObjects.filter(
            (fileObject) =>
              fileObject.compressionStatus === compressionStatuses.compressing
          ).length > 0,
        totalFileSize: fileObjects
          .filter(
            (file) => file.compressionStatus !== compressionStatuses.compressing
          )
          .reduce((sum, currentFileObject) => {
            return (sum += currentFileObject.file.size);
          }, 0),
      };
    });
  };
  // console.log("total file size parent", claimFormData.totalFileSize);
  const handleClaimFormChange = (e) => {
    setClaimFormData({
      ...claimFormData,
      [e.target.name]: e.target.value,
    });
  };

  const [wasSubmitted, setWasSubmitted] = useState(false);
  const handleOnInvalid = (e) => {
    setWasSubmitted(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWasSubmitted(true);
    // const claimPostBody = {
    //   deliveryId: orderInfo.deliveryId,
    //   ...claimFormData,
    // };
    if (!isValidEmail(claimFormData.emailAddress)) {
      toast.error("Please enter a valid email.");
      return;
    }
    if (claimFormData.files.length === 0) {
      toast.error(
        "Please submit at least 1 supporting document or image with your claim."
      );
      return;
    }
    if (claimFormData.totalFileSize > convertMBToBytes(TOTAL_FILE_SIZE_LIMIT)) {
      toast.error(`Total file size exceeds ${TOTAL_FILE_SIZE_LIMIT}MB limit`);
      return;
    }
    const claimPostBody = new FormData();
    // Object.entries(claimFormData).map((entry) => {
    //   if (entry[0] !== "files") {
    //     claimPostBody.append(entry[0], entry[1]);
    //   }
    // });
    const { files, ...claimRequest } = claimFormData;
    claimPostBody.append(
      "claimRequest",
      JSON.stringify({
        deliveryId: orderInfo.deliveryId,
        ...claimRequest,
      })
    );
    // const fileBlobs = files.map((file) => new Blob([file]));
    // file instanceof Blob; // true
    files.map((file) => {
      claimPostBody.append("file", file, file.name);
    });
    try {
      // console.log(claimPostBody);
      setLoading(true);
      const claimPostResponse = await postClaim(claimPostBody);
      toast.success("Your claim has been submitted successfully.");
      history.push("/claim");
      setLoading(false);
      // console.log(claimPostResponse)
    } catch (ex) {
      setLoading(false);
      toast.error("There was an issue submitting your claim.");
      handleApiError(ex);
    }
  };

  return (
    <form onSubmit={handleSubmit} onInvalid={handleOnInvalid}>
      <div className="paper-panel sub-panel">
        <div className="row sub-panel-header align-items-sm-center">
          <div className="col-6">
            <span className="h5">{mode}</span>
          </div>
        </div>
        <div className="font-500 my-2 mx-3">Your information</div>
        <div className="row px-4">
          <DiliTextCP
            maxLength={genericMaxLength}
            className="col-lg-4 form-group"
            required
            label="Contact Email"
            type="email"
            onChange={handleClaimFormChange}
            name="emailAddress"
            validationTest={(input) => {
              return isValidEmail(input);
            }}
            value={claimFormData.emailAddress}
            wasSubmitted={wasSubmitted}
          />
          <DiliTextCP
            maxLength={genericMaxLength}
            className="col-lg-4 form-group"
            label="Submitted By"
            required
            onChange={handleClaimFormChange}
            name="caller"
            value={claimFormData.caller}
            wasSubmitted={wasSubmitted}
          />
        </div>
        <div className="font-500 my-2 mx-3">Claim Information</div>
        <div className="row px-4">
          <DiliTextCP
            maxLength={25}
            className="col-lg-4 form-group"
            label="Claim Reference No"
            infoText="A reference number to find the claim later. You may reuse the invoice number or delivery ID of the order or any number you like."
            infoTextIconFloatRight
            required
            onChange={handleClaimFormChange}
            name="claimNo"
            value={claimFormData.claimNo}
            wasSubmitted={wasSubmitted}
          />
          <DiliTextCP
            type="select"
            className="col-lg-4 form-group"
            label="Claim Type"
            required
            onChange={handleClaimFormChange}
            name="claimType"
            value={claimFormData.claimType}
            wasSubmitted={wasSubmitted}
          >
            <option value="Lost Freight">Lost Freight</option>
            <option value="Damaged Freight">Damaged Freight</option>
            <option value="Missing Return">Missing Return</option>
            <option value="Repair Only">Repair Only</option>
            {/* Removed Uncollected COD and added Concealed Damage per management request 2-22-2024 and 2-23-2024*/}
            <option value="Concealed Damage">Concealed Damage</option>
          </DiliTextCP>

          <DiliTextCP
            type="number"
            className="col-lg-4 form-group"
            label="Amount"
            required
            onChange={handleClaimFormChange}
            name="amount"
            value={claimFormData.amount}
            blockScientificNotation
            positiveOnly
            decimalPrecision={2}
            // integerOnly
            wasSubmitted={wasSubmitted}
          />

          <DiliTextCP
            maxLength={genericMaxLength}
            className="col-lg-4 form-group"
            label="Part Number"
            onChange={handleClaimFormChange}
            name="partNo"
            required
            value={claimFormData.partNo}
            wasSubmitted={wasSubmitted}
          />
          <DiliTextCP
            maxLength={genericMaxLength}
            className="col-lg-4 form-group"
            label="Part Description"
            required
            onChange={handleClaimFormChange}
            name="partDescription"
            value={claimFormData.partDescription}
            wasSubmitted={wasSubmitted}
          />
          <DiliTextCP
            maxLength={genericTextAreaMaxLength}
            type="textarea"
            className="col-12 form-group"
            label="Comments"
            required
            onChange={handleClaimFormChange}
            name="comment"
            displayTextAreaCharacterCount
            value={claimFormData.comment}
            wasSubmitted={wasSubmitted}
          />
        </div>
        <div className="font-500 my-2 mx-3">
          Supporting Images and Documents{" "}
          <span className="required-star">*</span>{" "}
          <TooltipInfoHover>
            Upload at least 1 supporting document to help process your claim.
            You may include PDFs or Excel files showing dealer cost information
            or images showing damage, for example.
          </TooltipInfoHover>
        </div>
        <div className="row px-4">
          <div className="col-12">
            <FileUploadV2
              handleChangeFiles={handleChangeFiles}
              sizeLimitInMB={TOTAL_FILE_SIZE_LIMIT}
            />
          </div>
        </div>
      </div>
      <p>
        By submitting your claim, you agree to our{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer" //might not be necessary unless linking to a different site or in modern browsers. not 100% sure, need to research
          to={constants.pdfLinks.termsAndConditions}
        >
          terms and conditions
        </Link>{" "}
        and have read the{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={constants.pdfLinks.claimsProcedure}
        >
          claims procedure
        </Link>
        .
      </p>
      <button
        type="submit"
        className="btn btn-primary"
        disabled={claimFormData.compressingFiles}
      >
        {claimFormData.compressingFiles ? "Compressing Files" : "Submit"}
      </button>
    </form>
  );
};

const ReturnForm = ({
  mode,
  profileInfo,
  orderInfo,
  clientJWTInfo,
  history,
  setLoading,
}) => {
  const [returnFormData, setReturnFormData] = useState({
    quantity: "",
    reason: "Did not need Part",
    weight: "",
    comment: "",
    pieceType: "",
  });

  const [wasSubmitted, setWasSubmitted] = useState(false);
  const handleOnInvalid = () => {
    setWasSubmitted(true);
  };

  const handleReturnFormChange = (e) => {
    setReturnFormData({
      ...returnFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWasSubmitted(true);

    if (isClient() && mode === modeTitles.manualreturn) {
      toast.error("You do not have permission to submit a manual return.");
      return;
    }

    const returnPostBody = {
      originalDeliveryId: orderInfo.deliveryId,
      quantity: returnFormData.quantity,
      comment: returnFormData.reason + ": " + returnFormData.comment, //After looking at cnls code, deliveryEntEdit.aspx.cs, "ReturnsEntry" function. It does reason +": " + comment, So doing that here as well for now.
      weight: returnFormData.weight,
      pieceType: returnFormData.pieceType,
      isClient: isClient(),
    };

    try {
      setLoading(true);
      // await postReturn(returnPostBody);

      let returnDeliveryIdOrMessage;
      if (mode === modeTitles.manualreturn) {
        returnDeliveryIdOrMessage = (await postManualReturn(returnPostBody))
          .data;
      }

      if (mode === modeTitles.return) {
        returnDeliveryIdOrMessage = (await postReturn(returnPostBody)).data;
      }
      //if a customer is making a return but the client has set them to be by approval or denied they will get a message instead of the return delivery ID. E.g. "Return request has been posted and is awaiting approval."
      //if the response is an integer, i.e. the return was actually placed and a request was not made, we can go ahead with opening the label
      if (typeof returnDeliveryIdOrMessage === "number") {
        window.open(
          `${basePath}/view-labels/${returnDeliveryIdOrMessage}`,
          "_blank",
          "noopener popup,width=750,height=900"
        );
      }
      // const { data: labelsPDF } = await getLabelsForMultipleDeliveries(
      //   "" + returnDeliveryId,
      //   false,
      //   isClient()
      // );
      //Could possibly change message to say something else if a return request was made, e.g. A request for this return has been made with the client.
      toast.success("Your return has ben submitted successfully.");
      //should we download/display return table here based of label download/display preference in account settings?
      history.push("/order-history"); //returns are shown on order history for now, so send there.
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      toast.error("There was an issue submitting your return request.");
      handleApiError(ex);
    }
  };

  return (
    <form onSubmit={handleSubmit} onInvalid={handleOnInvalid}>
      <div className="paper-panel sub-panel">
        <div className="row sub-panel-header align-items-sm-center">
          <div className="col-12">
            <span className="h5">{mode}</span>
          </div>
        </div>

        <div className="row px-4">
          <DiliTextCP
            required
            type="select"
            className="col-lg-4 form-group"
            label="Reason"
            onChange={handleReturnFormChange}
            name="reason"
            value={returnFormData.reason}
            wasSubmitted={wasSubmitted}
          >
            <option value="Did not need Part">Did not need Part</option>
            <option value="Core Return">Core Return</option>
            <option value="Damaged Part">Damaged Part</option>
            <option value="Wrong Part">Wrong Part</option>
            <option value="Others">Others</option>
          </DiliTextCP>
          <DiliTextCP
            required
            type="number"
            className="col-lg-4 form-group"
            label="Package/Item Quantity"
            infoText="The amount of individual packages/items that will need to be picked up. The quantity should be equal to each item that will need its own label."
            onChange={handleReturnFormChange}
            name="quantity"
            value={returnFormData.quantity}
            blockScientificNotation
            positiveOnly
            integerOnly
            max="99"
            min="1"
            wasSubmitted={wasSubmitted}
            helperText="The # of labels needed"
            showHelperText
            helperTextClass="text-note tw-text-xs"
          />

          <DiliTextCP
            type="select"
            className="col-lg-4 form-group"
            label="Piece Type"
            onChange={handleReturnFormChange}
            name="pieceType"
            value={returnFormData.pieceType}
            wasSubmitted={wasSubmitted}
            required
          >
            <option value="">Select Piece Type</option>

            {Object.values(constants.pieceTypes).map((pieceType) => (
              <option key={pieceType.display} value={pieceType.value}>
                {pieceType.display}
              </option>
            ))}
          </DiliTextCP>

          {clientJWTInfo.WeightClient && (
            <DiliTextCP
              required
              type="number"
              className="col-md-4 form-group"
              label="Weight"
              onChange={handleReturnFormChange}
              name="weight"
              value={returnFormData.weight}
              integerOnly //weight is int on backend for ReturnRequest
              positiveOnly
              blockScientificNotation
              min="0"
              max="10000"
              wasSubmitted={wasSubmitted}
            />
          )}
          <DiliTextCP
            maxLength={genericTextAreaMaxLength}
            required
            type="textarea"
            className="col-12 form-group"
            label="Description"
            invalidText="Please enter a description of your problem."
            onChange={handleReturnFormChange}
            name="comment"
            value={returnFormData.comment}
            wasSubmitted={wasSubmitted}
          />
        </div>
      </div>
      <p>
        By submitting your return, you agree to our{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer" //might not be necessary unless linking to a different site or in modern browsers. not 100% sure, need to research
          to={constants.pdfLinks.termsAndConditions}
        >
          terms and conditions
        </Link>{" "}
        and have read the{" "}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={constants.pdfLinks.returnsProcedure}
        >
          returns procedure
        </Link>
        .
      </p>
      <button type="submit" className="btn btn-primary">
        Submit
      </button>
    </form>
  );
};

const modeTitles = constants.ActionCenterModes;

export const OrderActionCenterForm = ({
  mode,
  setMode,
  orderInfo,
  profileInfo,
  clientJWTInfo,
  history,
  setLoading,
}) => {
  //   const [actionType, setActionType] = useState(modeTitles.DeliveryConcern);
  // console.log(mode);
  // console.log(orderInfo);
  function renderDecider() {
    switch (mode) {
      case modeTitles.deliveryconcern:
      case modeTitles.codresearch:
        return (
          <DeliveryConcernAndCodResearchForm
            mode={mode}
            setMode={setMode} //this form needs set mode because it can swap between delivery concern and cod research modes itself
            orderInfo={orderInfo}
            profileInfo={profileInfo}
            clientJWTInfo={clientJWTInfo}
            history={history}
            setLoading={setLoading}
          />
        );
      case modeTitles.claim:
        return (
          <ClaimForm
            mode={mode}
            orderInfo={orderInfo}
            profileInfo={profileInfo}
            clientJWTInfo={clientJWTInfo}
            history={history}
            setLoading={setLoading}
          />
        );
      case modeTitles.manualreturn:
      case modeTitles.return:
        return (
          <ReturnForm
            mode={mode}
            orderInfo={orderInfo}
            profileInfo={profileInfo}
            clientJWTInfo={clientJWTInfo}
            history={history}
            setLoading={setLoading}
          />
        );

      default:
        return (
          <div>
            <h1>Invalid mode</h1>
          </div>
        );
    }
  }
  // console.log(process.env.NODE_ENV);

  return renderDecider();
};
